import { render } from "./retrieve.vue?vue&type=template&id=4c843480&scoped=true"
import script from "./retrieve.vue?vue&type=script&lang=js"
export * from "./retrieve.vue?vue&type=script&lang=js"

import "./retrieve.vue?vue&type=style&index=0&id=4c843480&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c843480"]])

export default __exports__